import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetProjectsForVendorDTO from "../../../models/DTO/IGetProjectsForVendorDTO";
import IOnGetProjectsDTO from "../../../models/DTO/IOnGetProjectsDTO";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import IOnProcessTakeOffDTO from "../../../models/DTO/IOnProcessTakeOffDTO";
import IProcessTakeOffDTO from "../../../models/DTO/IProcessTakeOffDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IProject from "../../../models/IProject";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {
    createActive: boolean;
    projects: IProject[];
    vendors: IVendorModel[];
    selectedVendor?: IVendorModel | null;
    clearVendorTypeahead: boolean;
    project_id?: number;
};

class TakeOffSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            projects: [],
            vendors: [],
            clearVendorTypeahead: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
        this.props.socket.on(EndpointsEnum.ProjectsOnGetProjectsForVendor, this.onGetProjects);
        this.props.socket.on(EndpointsEnum.TakeOffOnProcessTakeOff, this.onProcessTakeOff);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
        this.props.socket.removeListener(EndpointsEnum.ProjectsOnGetProjectsForVendor, this.onGetProjects);
        this.props.socket.removeListener(EndpointsEnum.TakeOffOnProcessTakeOff, this.onProcessTakeOff);
    }

    getProjects = () => {
        if (this.state.selectedVendor) {
            const payload: IGetProjectsForVendorDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.selectedVendor.guid,
            };

            this.props.socket.emit(EndpointsEnum.ProjectsGetProjectsForVendor, payload);
        }
    };

    onGetProjects = (data: IOnGetProjectsDTO) => {
        this.setState({
            projects: data.projects,
        });
    };

    selectedVendor = (vendor: IVendorModel) => {
        this.setState(
            {
                selectedVendor: vendor,
            },
            () => {
                this.getProjects();
            }
        );
    };

    findVendorsByName = (typeahead: string) => {
        const encodedTypeahead = encodeURIComponent(typeahead);

        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `name=${encodedTypeahead}`,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = _.map(data.supplierVendorTokens, (tokenData) => {
            return tokenData.Vendor!;
        });

        this.setState({
            vendors: foundVendors,
        });
    };

    clearTypeaheadCallback = () => {
        this.setState({
            selectedVendor: null,
        });
    };

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        if (this.state.selectedVendor && this.state.project_id) {
            const payload: IProcessTakeOffDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                takeOff: {
                    vendor_id: this.state.selectedVendor.id,
                    project_id: this.state.project_id,
                },
            };

            this.props.socket.emit(EndpointsEnum.TakeOffProcessTakeOff, payload);
        }
    };

    onProcessTakeOff = (data: IOnProcessTakeOffDTO) => {
        const notification: INotification = {
            message: "successfully_created_take_off_group",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.props.cancelFn();
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    render() {
        return (
            <div className={"TakeOffSidebar p-2"}>
                <div className={""}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} title={"take_off_group"} />
                    <hr />
                </div>

                <div className={""}>
                    <div className="mb-4">
                        <OwLabel
                            isBold={true}
                            title={"vendor"}
                            supplierModel={this.props.supplierModel}
                            isSupplierVendorOverride={true}
                            showIsReqAsterik={true}
                        />
                        <div className="position-relative">
                            <div>
                                <Typeahead
                                    className=""
                                    clearTypeahead={this.state.clearVendorTypeahead}
                                    clearTypeaheadCallback={() => {
                                        this.clearTypeaheadCallback();
                                    }}
                                    typeaheadItems={this.state.vendors}
                                    titleProp="name"
                                    subTitleProp=""
                                    maxResults={5}
                                    isRequired={true}
                                    placeholder="Search"
                                    selectedItem={this.state.selectedVendor}
                                    isSelectableFn={() => {
                                        return true;
                                    }}
                                    selectedItemFn={this.selectedVendor}
                                    typeaheadApiFn={this.findVendorsByName}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={"mb-4"}>
                        <OwLabel isBold={true} title={"project"} showIsReqAsterik={true} />
                        <div>
                            <OwSelectOption
                                valueProp={"id"}
                                titleProp={"name"}
                                options={this.state.projects}
                                fn={this.handleChange}
                                name={"project_id"}
                                selectedOption={this.state}
                                selectedOptionProp={"project_id"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <OwButton title={"create"} fn={this.create} active={this.state.createActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default TakeOffSidebar;
